import { Backdrop } from '@material-ui/core';
import { BlipChat } from 'blip-chat-widget';
import React, { createContext, useContext } from 'react';
import config from 'src/config';
import { createGlobalStyle } from 'styled-components';

const ChatsStyles = createGlobalStyle`
  #blip-chat-open-iframe {
    display: none !important;
    width: 48px !important;
    height: 48px !important;
  }
  #blip-chat-iframe {
    bottom: 24px !important;
  }

  .md-chat-widget-btn-wrapper {
    display: none !important;
  }
  .md-chat-widget-wrapper {
    bottom: 0 !important;
  }

  @media screen and (max-width: 480px), screen and (max-height: 420px) {
    #blip-chat-container #blip-chat-iframe {
      max-height: 92vh !important;
    }
  }
`;

interface IChatsContext {
  chatOpened: boolean;
  mountBlipChat: () => void;
  mountMovideskChat: () => void;
  destroyBlipChat: () => void;
  destroyMovideskChat: () => void;
  openBlipChat: () => void;
  openMovideskChat: () => void;
}

const ChatsContext = createContext<IChatsContext>(null as never);

let blipChatInstance: BlipChat | null = null;
let movideskInstance: HTMLScriptElement | null = null;

export default ({ children }) => {
  const [chatOpened, setChatOpened] = React.useState(false);

  function mountBlipChat() {
    if (blipChatInstance) return;

    blipChatInstance = new BlipChat()
      .withAppKey(config.env.blipChatToken)
      .withButton({ color: '#002e5b', icon: '' })
      .withCustomStyle(
        `
    #blip-chat-header {
      background-color: #002e5b !important; /* #f4aa00 */
    }
  `
      )
      .withCustomCommonUrl('https://chat.blip.ai/');

    blipChatInstance.build();
  }

  function mountMovideskChat() {
    if (movideskInstance) return;

    const scriptVar = document.createElement('script');
    movideskInstance = document.createElement('script');

    scriptVar.type = 'text/javascript';
    scriptVar.innerHTML = `var mdChatClient="${config.env.movideskToken}";`;

    movideskInstance.src =
      'https://chat.movidesk.com/Scripts/chat-widget.min.js';
    movideskInstance.async = true;

    document.body.appendChild(scriptVar);
    document.body.appendChild(movideskInstance);
  }

  function destroyBlipChat() {
    if (!blipChatInstance) return;
    blipChatInstance.destroy();
  }

  function destroyMovideskChat() {
    if (!movideskInstance) return;
    document.body.removeChild(movideskInstance);
    movideskInstance = null;
  }

  function openBlipChat() {
    const btn = document.getElementById('blip-chat-open-iframe');
    if (btn) {
      btn.click();
      setChatOpened(!chatOpened);
    }
  }

  function openMovideskChat() {
    const btn = document.getElementsByClassName('md-chat-widget-btn-wrapper');
    if (btn && btn.length) {
      btn.item(0)?.['click']();
      setChatOpened(!chatOpened);
    }
  }

  function closeAll() {
    openBlipChat();
    openMovideskChat();
  }

  //? remove state do movidesk se existir ao atualizar a pagina
  React.useEffect(() => {
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.includes('chatWidgetWindow')) {
          localStorage.removeItem(key);
          break;
        }
      }
    } catch {
      //
    }
  }, []);

  return (
    <ChatsContext.Provider
      value={{
        chatOpened,
        mountBlipChat,
        mountMovideskChat,
        destroyBlipChat,
        destroyMovideskChat,
        openBlipChat,
        openMovideskChat
      }}
    >
      <ChatsStyles />
      <Backdrop style={{ zIndex: 9998 }} open={chatOpened} onClick={closeAll} />
      {children}
    </ChatsContext.Provider>
  );
};

export function useChats() {
  return useContext(ChatsContext);
}
